import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import toast from "react-hot-toast";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import {
  deleteUserOfListPatients,
  getAllPatientsOfProvider,
} from "../../../../services/rest/users/userProviderService";
import { useDispatch, useSelector } from "react-redux";
import { setListPatients } from "../../../../redux/slice/patientsSlice";
import { handleError } from "../../../../utils/handleError";

function createData(
  _id,
  firstName,
  lastName,
  email,
  phoneNumber,
  membership,
  rol
) {
  return {
    _id,
    firstName,
    lastName,
    email,
    phoneNumber,
    membership,
    rol,
  };
}

const ModalDeletePatient = ({ open, setOpen, setLoading, selectedUser }) => {
  const { _id } = useSelector((state) => state.userReducer);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  const dispatch = useDispatch();

  const deleteUser = async () => {
    try {
      setLoading(true);
      //Hacer peticion a la APi de eliminar usuario, el id del usuario a eliminar esta en selectedUser a lista de pacientes
      //Si se elimino bien hacer peticion a lista de pacientes y rellenar redux con listPatients y listaAllUsers
      const formatRows = [];
      await deleteUserOfListPatients(selectedUser?._id, _id);
      const responseListPatients = await getAllPatientsOfProvider(_id);
      responseListPatients.forEach((patient) => {
        if (patient?.userId) {
          formatRows.push(
            createData(
              patient?.userId ?? 0,
              patient?.firstName ?? "---",
              patient?.lastName ?? "---",
              patient?.email ?? "---",
              patient?.phone ?? 0,
              patient?.membership ?? "---",
              patient?.rol ?? "---"
            )
          );
        }
      });
      // console.log("Pacientes encontrados", formatRows);
      dispatch(setListPatients({ listPatients: formatRows }));
      // console.log("User selected", selectedUser);

      toast.success("Se eliminó con éxito de tu lista de pacientes");
      handleClose();
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `No pudimos eliminar al paciente en este momento. \n ${message}`
      );
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center" }}>
            ¿Estas seguro de eliminar a {selectedUser?.firstName} de tus
            pacientes?
          </Typography>
        </DialogTitle>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            // onClick={handleClose}
            sx={{ borderColor: "white", color: "white" }}
            startIcon={<PersonRemoveIcon />}
            onClick={deleteUser}
          >
            Eliminar Paciente
          </Button>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDeletePatient;
